import { formatCurrency } from '@gap/utils/utils'

// Pinned so every dollar carries its country (US$, NZ$, A$, CA$) whatever the viewer's browser locale; a bare "$"
// is ambiguous for the USD-fallback countries.
const BILLING_LOCALE = 'en-GB'

/** Formats a Chargebee amount (smallest unit, e.g. cents); whole amounts drop the decimals unless `fractionDigits` is given. */
export const formatBillingAmount = (params: { amount: number; currencyCode: string; fractionDigits?: number }): string => {
   const value = params.amount / 100
   return formatCurrency({
      value,
      currencyCode: params.currencyCode,
      currencyDisplay: 'symbol',
      locale: BILLING_LOCALE,
      fractionDigits: params.fractionDigits ?? (Number.isInteger(value) ? 0 : 2),
   })
}
